{
  "name": "app",
  "version": "2.14.17",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "tw:build": "node scripts/wrap-bootstrap.js && tailwindcss -i src/styles.css -o src/styles.gen.css",
    "tw:watch": "tailwindcss -i src/styles.css -o src/styles.gen.css --watch",
    "start:ng": "node --max_old_space_size=6000 ./node_modules/@angular/cli/bin/ng serve --host=0.0.0.0 --disable-host-check --port 4200 --no-hmr",
    "start": "npm run tw:build && concurrently -k -n tw,ng -c blue,green \"npm:tw:watch\" \"npm:start:ng\"",
    "start:ng:ssl": "npm run start:ng -- --ssl",
    "start:ssl": "npm run tw:build && concurrently -k -n tw,ng -c blue,green \"npm:tw:watch\" \"npm:start:ng:ssl\"",
    "start-prod": "npm run tw:build && ng serve --aot",
    "prod": "npm run tw:build && ng serve --configuration=prod",
    "deploy-dev": "npm run tw:build && ng build --configuration=dev && firebase deploy --only hosting:dev-app",
    "deploy-prod": "npm run tw:build && ng build --configuration=prod && firebase deploy --only hosting:app && node build-script.js",
    "build": "npm run tw:build && ng build",
    "test": "ng test",
    "build-stats": "ng build --configuration=prod --output-hashing=none --stats-json",
    "stats": "webpack-bundle-analyzer dist/app/stats.json",
    "stats-exp": "ng build && source-map-explorer dist/app/**/*.js",
    "e2e": "npx playwright test",
    "e2e:ui": "npx playwright test --headed --ui",
    "gitpd": "git push origin development",
    "claude": "claude --add-dir ../Backend",
    "build-8G": "npm run tw:build && node --max_old_space_size=8000 ./node_modules/@angular/cli/bin/ng build --configuration=prod "
  },
  "private": true,
  "dependencies": {
    "@angular-devkit/core": "22.0.7",
    "@angular/animations": "22.0.7",
    "@angular/common": "22.0.7",
    "@angular/compiler": "22.0.7",
    "@angular/core": "22.0.7",
    "@angular/elements": "22.0.7",
    "@angular/forms": "22.0.7",
    "@angular/google-maps": "^22.0.5",
    "@angular/localize": "22.0.7",
    "@angular/platform-browser": "22.0.7",
    "@angular/platform-browser-dynamic": "22.0.7",
    "@angular/router": "22.0.7",
    "@fullcalendar/angular": "6.1.21",
    "@fullcalendar/core": "6.1.21",
    "@fullcalendar/daygrid": "6.1.21",
    "@googlemaps/js-api-loader": "^2.1.1",
    "@maskito/angular": "^5.3.1",
    "@maskito/core": "^5.3.1",
    "@ngrx/effects": "21.1.1",
    "@ngrx/entity": "21.1.1",
    "@ngrx/router-store": "21.1.1",
    "@ngrx/store": "21.1.1",
    "@ngrx/store-devtools": "21.1.1",
    "@ngx-progressbar/core": "5.3.2",
    "@popperjs/core": "2.11.8",
    "@sentry/angular": "^10.66.0",
    "@sentry/browser": "^10.66.0",
    "@stripe/stripe-js": "5.8.0",
    "@swimlane/ngx-datatable": "24.0.1",
    "@textcomplete/core": "0.1.13",
    "@textcomplete/textarea": "0.1.13",
    "@types/google.maps": "^3.65.2",
    "angular-code-input": "2.0.0",
    "angularx-qrcode": "^21.0.5",
    "autoprefixer": "^10.5.4",
    "big.js": "7.0.1",
    "chart.js": "^4.5.1",
    "core-js": "^3.49.0",
    "d3-shape": "3.2.0",
    "dropzone": "6.0.0-beta.2",
    "elkjs": "^0.10.0",
    "file-saver": "2.0.5",
    "flatpickr": "4.6.13",
    "jquery": "3.7.1",
    "jszip": "^3.10.1",
    "moment": "2.30.1",
    "moment-timezone": "^0.6.2",
    "ng-recaptcha": "13.2.1",
    "ngx-infinite-scroll": "^22.0.0",
    "ngx-papaparse": "8.0.0",
    "ngx-popperjs": "15.0.4",
    "nxt-sortablejs": "20.0.0",
    "openseadragon": "5.0.1",
    "pdfjs-dist": "^2.16.105",
    "rete": "^2.0.6",
    "rete-angular-plugin": "^2.7.1",
    "rete-area-plugin": "^2.3.2",
    "rete-connection-path-plugin": "^2.0.4",
    "rete-connection-plugin": "^2.0.5",
    "rete-engine": "^2.1.1",
    "rete-render-utils": "^2.0.3",
    "rete-structures": "^2.0.3",
    "rxjs": "7.8.2",
    "shortcut-buttons-flatpickr": "0.3.1",
    "signature_pad": "^5.1.3",
    "slim-select": "^4.0.6",
    "socket.io-client": "^4.8.3",
    "sortablejs": "^1.15.7",
    "swiper": "^12.2.0",
    "tslib": "2.8.1",
    "uuid": "^13.0.2",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "22.0.7",
    "@angular/cli": "22.0.7",
    "@angular/compiler-cli": "22.0.7",
    "@fullhuman/postcss-purgecss": "5.0.0",
    "@playwright/test": "1.61.1",
    "@tailwindcss/cli": "^4.3.2",
    "@tailwindcss/forms": "^0.5.11",
    "@tailwindcss/postcss": "^4.3.2",
    "@types/jasmine": "4.3.6",
    "@types/node": "^22.20.1",
    "axios": "^1.18.1",
    "istanbul-lib-instrument": "^6.0.3",
    "concurrently": "^10.0.3",
    "flowbite": "^4.0.2",
    "jasmine-core": "4.5.0",
    "jasmine-marbles": "0.9.2",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-cli": "2.0.0",
    "karma-coverage-istanbul-reporter": "3.0.3",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "^2.2.0",
    "postcss": "^8.5.20",
    "sass": "^1.101.0",
    "source-map-explorer": "2.5.3",
    "tailwindcss": "^4.3.2",
    "typescript": "^6.0.3",
    "webpack-bundle-analyzer": "4.8.0"
  }
}
